import React, {useRef, useEffect} from "react";
import {useMutation} from "react-admin";
import {Grid, Box} from "@material-ui/core";

import ChatConversation from "./ChatConversation";
import ChatTextInputBar from "./ChatTextInputBar";
import {useNotifyError} from "../../utils/notifiers/useNotifyError";
import {resizeElementHeight} from "../../utils/htmlElementTransform";
import {utcStr2localStr} from "../_helpers/dateTime";

// Layout padding used by enclosing TabbedShowLayout — kept local so this
// component doesn't depend on any particular Show page's constants.
const CHAT_LAYOUT_PADDING = 8;


const Plug = () => (
	<Grid item xs={false} sm={1} md={2} lg={2} xl={3}/>
)

function ChatContainer({resource, resourcePath, record, onGetMessages, ...other}) {
	const notifyError = useNotifyError();

	const [fetchAllMessages, {data, total, loading, error}] = useMutation({
		type: 'getList',
		resource: resourcePath,
		payload: {
			pagination: {page: 1, perPage: 1},
			sort: {field: 'created_at', order: 'ASC'},
			filter: {no_range: true}
		}}, {
		onSuccess: (data) => {
			for(const item of data.data){
				item.created_at = utcStr2localStr(item.created_at);
			}
		},
	});

	const [mutate] = useMutation({
		resource: resourcePath,
	}, {
		onSuccess: fetchAllMessages,
		onFailure: (error) => {
			notifyError(error);
		}
	});

	const sendMessage = (message) => {
		mutate({
			type: 'create',
			payload: {
				data: {
					body: message,
				}
			},
		});
	};

	const chatConversationRef = useRef(null);

	useEffect(() => {
		function handleResize() {
			if (chatConversationRef.current) resizeElementHeight(chatConversationRef.current, -CHAT_LAYOUT_PADDING);
		}

		handleResize()
		window.addEventListener('resize', handleResize)
		return _ => {
			window.removeEventListener('resize', handleResize)
		}
	}, []);

	useEffect(() => {
		fetchAllMessages();
	}, [fetchAllMessages]);

	useEffect(() => {
		if (onGetMessages && total) {
			// Keep the callback contract stable: pass the logical resource name
			// (e.g. "orders") so redux reducers can match it; fall back to the
			// full path for callers that don't set one.
			onGetMessages(resource || resourcePath, record, total)
		}
	}, [total]);

	useEffect(() => {
		if (error) notifyError(error);
	}, [error]);

	return (
		<Box style={{
			display: "flex",
			flexFlow: "column nowrap",
			margin: 0
		}}
			 ref={chatConversationRef}
		>
			<Grid container justify={"center"}
				  style={{
					  flex: "0 0 auto",
				  }}>
				<Plug/>
				<Grid item xs={12} sm={10} md={8} lg={8} xl={6}>
					<ChatTextInputBar sendMessage={sendMessage}/>
				</Grid>
				<Plug/>
			</Grid>
			<Grid container justify={"center"}
				  style={{
					  flex: "1 auto",
					  height: "100%",
					  overflow: "hidden",
					  overflowY: "scroll"

				  }}>
				<Plug/>
				<ChatConversation
					messages={data}
					loading={loading}
					item
					xs={12} sm={10} md={8} lg={8} xl={6}/>
				<Plug/>
			</Grid>

		</Box>
	);
}

export default ChatContainer;
